/* eslint max-classes-per-file: 0 */

import {
  FormTemplate as Data,
  FormTemplateCollection as Collection,
} from '@/typings/api/FormTemplate'
import { FormTemplatesApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class FormTemplatesTransformerParams extends TransformerParams {
}

// @ts-ignore TODO
export class FormTemplatesAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new FormTemplatesTransformerParams();
}
